import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

	const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/seating_plan/:run_id',
		name: 'SeatingPlan',
		component: () => import(/* webpackChunkName: "plan" */ '../views/SeatingPlan.vue')
	},
	{
		path: '/users',
		name: 'Users',
		component: () => import(/* webpackChunkName: "users" */ '../views/Users.vue')
	},
	{
		path: '/user/:user_id',
		name: 'User',
		component: () => import(/* webpackChunkName: "user" */ '../views/User.vue')
	},
	{
		path: '/groups',
		name: 'Groups',
		component: () => import(/* webpackChunkName: "groups" */ '../views/Groups.vue')
	},
	{
		path: '/group/:group_id',
		name: 'Group',
		component: () => import(/* webpackChunkName: "group" */ '../views/Group.vue')
	},
	{
		path: '/account',
		name: 'Account',
		component: () => import(/* webpackChunkName: "account" */ '../views/Account.vue')
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
	},
	{
		path: '/logout',
		name: 'Logout',
		component: () => import(/* webpackChunkName: "logout" */ '../views/Logout.vue')
	},
	{
		path: '/help',
		name: 'Help',
		component: () => import(/* webpackChunkName: "help" */ '../views/Help.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
